import type { FieldDef, FormSchema } from '../types';

import propertyToFieldDef from './propertyToFieldDef';

const toFieldDefs = (schema: FormSchema | null | undefined): FieldDef[] => {
  if (!schema?.properties) return [];

  const keys = schema['x-ui']?.order ?? Object.keys(schema.properties);
  const required = new Set(schema.required ?? []);

  return keys
    .filter((key) => key in schema.properties)
    .map((key) => propertyToFieldDef(key, schema.properties[key], required.has(key)));
};

export default toFieldDefs;
